module.exports = __webpack_public_path__ + "media/images/subject_img/MORSE-ee50f4fd8a44f37e5de6e453a1a36a2e.jpg";